import React, { useState, useEffect } from "react";
import "./genderWishShop.scss";
import { Link, useParams } from "react-router-dom";
import BottomPart from "../../components/bottomPart/BottomPart";
import filterStore from "../../store/filterStore";

import categoryStore from "../../store/categoryStore";
import { CATEGORY_IMAGE_URL } from "../../constant";

import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";
// import required modules
import { Grid, useMediaQuery, Skeleton } from "@mui/material";
import productStore from "../../store/productStore";
import SmallProductCard from "../../components/smallProductCard/SmallProductCard";
import SmallProductCardSkeleton from "../../components/smallProductCard/SmallProductCardSkeleton";

const GenderWishShop = () => {
  const params = useParams();
  const maxWidth_1440 = useMediaQuery("(max-width:1440px)");
  const maxWidth_1160 = useMediaQuery("(max-width:1160px)");
  const maxWidth_900 = useMediaQuery("(max-width:900px)");
  const maxWidth_780 = useMediaQuery("(max-width:780px)");
  const maxWidth_620 = useMediaQuery("(max-width:620px)");
  const maxWidth_450 = useMediaQuery("(max-width:450px)");
  const maxWidth_300 = useMediaQuery("(max-width:300px)");

  const CategoryStore = categoryStore();
  const ProductStore = productStore();
  const [gender, setGender] = useState();
  const [genderCategory, setGenderCategory] = useState(null);
  const [genderProduct, setGenderProduct] = useState();

  const categoryLoading = [1, 2, 3, 4];

  const FilterStore = filterStore();

  useEffect(() => {
    FilterStore.resetFilters();
  }, []);

  useEffect(() => {
    if (params.gender === "men") {
      setGender("M");
    }
    if (params.gender === "women") {
      setGender("W");
    }
    if (params.gender === "kids") {
      setGender("K");
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [params.gender]);

  useEffect(() => {
    getCategory();
  }, [gender, CategoryStore.category]);

  const getCategory = () => {
    const data = [];
    if (CategoryStore.category) {
      CategoryStore.category.map((item) => {
        if (item.status === "A") {
          if (gender === "W") {
            item.isWomenImage === true &&
              data.push({
                _id: item._id,
                categoryName: item.categoryName,
                categoryImage: item.categoryImageOfWomen,
              });
          }
          if (gender === "M") {
            item.isMenImage === true &&
              data.push({
                _id: item._id,
                categoryName: item.categoryName,
                categoryImage: item.categoryImageOfMen,
              });
          }
          if (gender === "K") {
            item.isKidsImage === true &&
              data.push({
                _id: item._id,
                categoryName: item.categoryName,
                categoryImage: item.categoryImageOfKids,
              });
          }
        }
      });
      setGenderCategory(data);
    }
  };

  useEffect(() => {
    getProduct();
  }, [genderCategory, ProductStore.mProduct]);

  const getProduct = () => {
    if (gender && ProductStore.mProduct) {
      const productData = [];
      genderCategory.map((category) => {
        const singleCategoryProduct = [];
        ProductStore.mProduct.map((product) => {
          product.gender.map((g) => {
            if (
              g === gender &&
              product.categoryID === category._id &&
              product.publish
            ) {
              singleCategoryProduct.push(product);
            }
          });
        });
        if (singleCategoryProduct.length) {
          productData.push({
            categoryName: category.categoryName,
            product: singleCategoryProduct,
          });
        }
      });
      setGenderProduct(productData);
    }
  };

  return (
    <div className="gender-wish-shop">
      <div className="gender-wish-shop-container">
        {/* <p>Gender : {params.gender} as {gender}</p> */}
        <div className="categories">
          <div className="titles">Categories</div>
          <div className="category-container">
            {genderCategory
              ? genderCategory.map((item) => (
                  <Link
                    to={`${item.categoryName}/${item._id}`}
                    className="single-category-container"
                    key={item._id}
                  >
                    <div className="category-image">
                      <img
                        src={`${CATEGORY_IMAGE_URL}${item.categoryImage}`}
                        alt="category-img"
                      />
                    </div>
                    <div className="category-name">{item.categoryName}</div>
                  </Link>
                ))
              : categoryLoading.map((item) => (
                  <Link className="single-category-container" key={item}>
                    <div className="category-image">
                      <Skeleton
                        animation="wave"
                        variant="circular"
                        component="img"
                      />
                    </div>
                    <Skeleton animation="wave">
                      <div className="category-name">{item}</div>
                    </Skeleton>
                  </Link>
                ))}
          </div>
        </div>
        <div>
          {genderProduct ? (
            genderProduct.map((item) => (
              <div className="particular-category" key={item.categoryName}>
                <div className="titles">{item.categoryName}</div>
                <div className="swiper-container">
                  <Swiper
                    slidesPerView={
                      maxWidth_300
                        ? 1
                        : maxWidth_450
                        ? 1.5
                        : maxWidth_620
                        ? 2
                        : maxWidth_780
                        ? 3
                        : maxWidth_900
                        ? 3.5
                        : maxWidth_1160
                        ? 4
                        : maxWidth_1440
                        ? 5
                        : 6
                    }
                    spaceBetween={0}
                    className="mySwiper"
                  >
                    {item.product
                      .slice(0, 6)
                      .reverse()
                      .map((item) => (
                        <SwiperSlide key={item._id}>
                          <div className="single-card">
                            <SmallProductCard
                              item={item}
                              myGender={params.gender}
                            />
                          </div>
                        </SwiperSlide>
                      ))}
                  </Swiper>
                </div>
              </div>
            ))
          ) : (
            <div className="particular-category">
              <Skeleton animation="wave">
                <div className="titles">Title</div>
              </Skeleton>
              <div className="swiper-container">
                <Swiper
                  slidesPerView={
                    maxWidth_300
                      ? 1
                      : maxWidth_450
                      ? 1.5
                      : maxWidth_620
                      ? 2
                      : maxWidth_780
                      ? 3
                      : maxWidth_900
                      ? 3.5
                      : maxWidth_1160
                      ? 4
                      : maxWidth_1440
                      ? 5
                      : 6
                  }
                  spaceBetween={0}
                  className="mySwiper"
                >
                  <SwiperSlide>
                    <div className="single-card">
                      <SmallProductCardSkeleton />
                    </div>
                  </SwiperSlide>
                </Swiper>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default GenderWishShop;
